import { useMemo } from 'react'

import type { PerformanceFactoryParams } from './performanceFactory'
import { performanceFactory } from './performanceFactory'

type Props = PerformanceFactoryParams | undefined

/**
 * Hook providing memoized fwnPerformance instance
 */
export function usePerformance(params: Props) {
  const type = params?.type
  const widget_id = params?.widget_id
  const channel = params?.channel
  const channel_id = params?.channel_id
  const hashtag = params?.hashtag
  const playlist = params?.playlist
  const video = params?.video
  const hasParams = params !== undefined

  return useMemo(
    () =>
      hasParams
        ? performanceFactory({
            type,
            widget_id,
            channel,
            channel_id,
            hashtag,
            playlist,
            video,
          })
        : undefined,
    [hasParams, type, widget_id, channel, channel_id, hashtag, playlist, video],
  )
}
